import type { ReactNode, CSSProperties } from "react";
import type { CmsBackground } from "@/lib/api/cms-windows";
import { backgroundToStyle } from "./bgStyle";

/**
 * WEmpty — passthrough kontener dla okien (`w_*`).
 *
 * **Rola:** semantyczny `<section>` BEZ wizualnej oprawy (bez tła/ramki/h3).
 * Treść okna sama zarządza swoim layoutem (np. `WMenu` w stopce, breadcrumbs,
 * `WPath` jako pasek bez ramki). Wcześniej rolę pełnił `KEmpty`/`KClear` w
 * `WindowContainer.tsx`.
 *
 * **2 opcje konfiguracji** (props):
 *   - **treść** (`children`) — content variant'a okna
 *   - **tło** (`background`) — `CmsBackground` aplikowany jako inline style;
 *     gdy null/empty, czyste passthrough bez inline style.
 *
 * Brak `title` props — `WEmpty` z założenia NIE renderuje nagłówka okna.
 * Jeśli variant chce header, robi to wewnątrz swojego markup.
 */
export function WEmpty({ background, children }: WEmptyProps) {
  const bgStyle: CSSProperties | undefined = (() => {
    const s = backgroundToStyle(background);
    return Object.keys(s).length > 0 ? s : undefined;
  })();

  return <section style={bgStyle}>{children}</section>;
}

export type WEmptyProps = {
  background?: CmsBackground | null;
  children: ReactNode;
};
